import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CssLoaderService {
  
  private loadedStyles = new Set<string>();

  loadNonCriticalStyles(): void {
    // Non-critical styles are now included in the main styles.scss file
    // This method is kept for potential future use
    if (this.loadedStyles.has('non-critical')) {
      return;
    }
    this.loadedStyles.add('non-critical');
  }

  private loadStyle(href: string): void {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'print';
    link.onload = () => {
      link.media = 'all';
    };
    document.head.appendChild(link);
  }

  loadFullStyles(): void {
    // The main styles are already loaded, just ensure they're applied
    // This method can be used for any additional style loading if needed
  }
} 